<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.EDIT') }}
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedDisputeStatus"
          :items="statusOptions"
          :label="$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.STATUS')"
          outlined
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CANCEL') }}
        </v-btn>
        <v-btn color="primary" class="secondary--text" @click="save()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'EditDisputeDialog',
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      statusOptions: ['INITIATED', 'UNRESOLVED', 'APPROVED', 'REJECTED'],
      selectedDisputeStatus: ''
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('disputes', ['disputes', 'selectedDispute']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.setSelectedDispute(undefined)
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    selectedDispute() {
      if (this.selectedDispute) {
        this.selectedDisputeStatus = this.selectedDispute.Status
      }
    }
  },
  methods: {
    ...mapActions('disputes', ['putDispute']),
    ...mapMutations('disputes', [
      'setSelectedDispute',
      'setSelectedDisputeValue'
    ]),
    async save() {
      await this.putDispute({
        ID: this.selectedDispute.ID,
        newStatus: this.selectedDisputeStatus
      })
      this.show = false
    }
  }
}
</script>
